import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import * as RadixLabel from '@radix-ui/react-label';

// Utils
import bemify from 'utils/bemify';

// Components
import Icon from 'components/icon';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const Checkbox = forwardRef(({ className = null, checked = false, disabled = false, id, icon = null, iconMarginSize = 's', label = null, onCheckedChange = () => {}, ...checkboxProps }, ref) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (value) => {
    setIsChecked(value);
    onCheckedChange(value, label);
  };

  useEffect(() => {
    setIsChecked(checked);
    onCheckedChange(checked, label);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  return (
    <div
      className={`${styles.checkbox}${
        disabled ? ` ${styles.checkbox_disabled}` : ''}${
        className ? ` ${className}` : ''}`}
    >
      <RadixCheckbox.Root
        ref={ref}
        checked={isChecked}
        className={styles.checkbox__input}
        disabled={disabled}
        id={id}
        onCheckedChange={handleCheckboxChange}
        {...checkboxProps}
      >
        <RadixCheckbox.Indicator>
          <Icon
            className={styles.checkbox__checkIcon}
            name="check"
          />
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      {label && (
        <RadixLabel.Root
          className={`${styles.checkbox__label}${disabled ? ` ${styles.checkbox__label_disabled}` : ''}`}
          htmlFor={id}
        >
          {!!icon && (
            <Icon
              className={`${styles.checkbox__icon}${
                iconMarginSize === 'l' ? ` ${styles.checkbox__icon_marginLarge}` : ''}`}
              name={icon}
            />
          )}
          {label}
        </RadixLabel.Root>
      )}
    </div>
  );
});

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconMarginSize: PropTypes.oneOf(['s', 'l']),
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  onCheckedChange: PropTypes.func
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
